import Chip from '@/atoms/Chip';
import { VARIANT_COLOR_ENUM } from '@/types/utils';
import ModalClassicLayout from 'context/Modal/layout/Classic';
import { useDecksDetails } from 'hooks/queries/decks';
import { useTranslation } from 'react-i18next';

type Props = {
  deckId: string;
  closeModal: () => void;
};

const LegalLine = ({ resumeKey, legal }: { resumeKey: string; legal: boolean }) => {
  const { t } = useTranslation();

  return (
    <p className="flex justify-between">
      {t(`deck.modal.legality.${resumeKey}`)}
      <Chip color={legal ? VARIANT_COLOR_ENUM.SUCCESS : VARIANT_COLOR_ENUM.ERROR}>
        {t(legal ? 'legal' : 'not-legal')}
      </Chip>
    </p>
  );
};

const DeckLegalDetail = ({ deckId, closeModal }: Props) => {
  const {
    queryResult: { data },
  } = useDecksDetails(deckId);
  const { t } = useTranslation();

  return (
    <ModalClassicLayout closeModal={closeModal} title={t('deck.modal.legality.title')}>
      {data?.deckLegality?.resume && (
        <div className="flex flex-col gap-2">
          <LegalLine legal={data.deckLegality.resume.globalValidity!} resumeKey="globalValidity" />
          <LegalLine legal={data.deckLegality.resume.isOwned!} resumeKey="isOwned" />
          <LegalLine legal={data.deckLegality.resume.nbCards!} resumeKey="nbCards" />
          <LegalLine legal={data.deckLegality.resume.nbRare!} resumeKey="nbRare" />
          <LegalLine legal={data.deckLegality.resume.nbUnique!} resumeKey="nbUnique" />
          <LegalLine legal={data.deckLegality.resume.nbFamily!} resumeKey="nbFamily" />
          <LegalLine legal={data.deckLegality.resume.isSuspended!} resumeKey="isSuspended" />
        </div>
      )}
    </ModalClassicLayout>
  );
};

export default DeckLegalDetail;
